import { useState, useEffect } from 'react'
import { supabase } from '../services/supabase'

export function useCustomers(page = 1, pageSize = 100) {
  const [customers, setCustomers] = useState([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    fetchCustomers()
  }, [page])

  const fetchCustomers = async () => {
    try {
      setLoading(true)
      const from = (page - 1) * pageSize
      const to = from + pageSize - 1

      const { data, count, error: err } = await supabase
        .from('customers')
        .select('*', { count: 'exact' })
        .range(from, to)

      if (err) throw err
      setCustomers(data || [])
      setTotal(count || 0)
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  const createCustomer = async (customerData) => {
    const { data, error } = await supabase
      .from('customers')
      .insert([customerData])
      .select()
    if (error) throw error
    return data[0]
  }

  return { customers, total, loading, error, createCustomer, refetch: fetchCustomers }
}
